export const CASE_STATUS_LABELS = {
  new_request: "Nouvelle demande",
  to_contact: "À contacter",
  contacted: "Contactée",
  information_missing: "Informations manquantes",
  assessment_in_progress: "Évaluation en cours",
  quote_in_progress: "Devis en préparation",
  quote_sent: "Devis envoyé",
  follow_up: "À relancer",
  accepted: "Accepté",
  planning_pending: "Planification à effectuer",
  scheduled: "Planifié",
  mission_in_progress: "Mission en cours",
  completed: "Terminée",
  refused: "Refusé",
  cancelled: "Annulé",
  archived: "Archivé",
};

export const QUOTE_STATUS_LABELS = {
  draft: "Brouillon", to_review: "À vérifier", validated: "Validé en interne",
  sent: "Envoyé", viewed: "Consulté", change_requested: "Modification demandée",
  accepted: "Accepté", refused: "Refusé", expired: "Expiré", cancelled: "Annulé",
};

export const MISSION_STATUS_LABELS = {
  draft: "Brouillon", to_plan: "À planifier", provisional: "Provisoire",
  confirmed: "Confirmée", team_informed: "Équipe informée", en_route: "En route",
  arrived: "Arrivée", loading: "Chargement", transport: "Transport",
  unloading: "Déchargement", completed: "Terminée", incident: "Incident", cancelled: "Annulée",
};

export const TASK_STATUS_LABELS = {
  todo: "À faire", in_progress: "En cours", waiting: "En attente", done: "Terminée", cancelled: "Annulée",
};

export const INCIDENT_STATUS_LABELS = {
  declared: "Déclaré", analyzing: "En analyse", action_required: "Action requise",
  waiting: "En attente", resolved: "Résolu", closed: "Clôturé",
};

export const INVOICE_STATUS_LABELS = {
  draft: "Brouillon", issued: "Émise", partially_paid: "Partiellement réglée",
  paid: "Réglée", late: "En retard", cancelled: "Annulée", credited: "Avoir émis",
};

export function euros(cents) {
  const v = (cents || 0) / 100;
  return v.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
}

export const CASE_STATUS_KEYS = Object.keys(CASE_STATUS_LABELS);

export const PROFILE_LABELS = {
  particulier: "Particulier",
  entreprise: "Entreprise",
  institution: "Institution",
  reservation_place: "Groupage",
};

export const ORG_TYPE_LABELS = {
  entreprise: "Entreprise",
  collectivite: "Collectivité",
  association: "Association",
  bailleur: "Bailleur",
  ecole: "École",
  medical: "Établissement médical",
  autre: "Autre",
};

export const CONTACT_TYPE_LABELS = {
  particulier: "Particulier",
  professionnel: "Professionnel",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR");
  } catch {
    return iso;
  }
}
export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR");
  } catch {
    return iso;
  }
}
